export enum ActionMessages{
  _1 ='Action Required!',
  _2 ='Program is Fully Routed And Approved',
  _3 ='Change Exception is Fully Routed And Approved',
  _4 ='A New Comment Has Been Posted For Your Review',
  _5 = 'Product Removal',
  _6 = 'Do you want to Copy the Products and Accruals Rates?'
}